/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API
}
export default {
  utils: {
    uploadFile: `${base.url}/analyse/util/uploadTemplate`
  },
  //账户概况
  accountAnalyseVn: {
    getData: `${base.url}/analyse/accountAnalyseVn/getData`,
    getAccountSurvey: `${base.url}/analyse/accountAnalyseVn/getAccountSurvey`,
    getDataActivate: `${base.url}/analyse/accountAnalyseVn/getDataActivate`,
    accountExport: `${base.url}/analyse/accountAnalyseVn/accountExport`,
    activateExport: `${base.url}/analyse/accountAnalyseVn/activateExport`
  },
  //存款概况
  chshinAnalyseVn: {
    getData: `${base.url}/analyse/chshinAnalyseVn/getData`,
    getDeposit: `${base.url}/analyse/chshinAnalyseVn/getDeposit`,
    depositExport: `${base.url}/analyse/chshinAnalyseVn/depositExport`,
    getDepositMoney: `${base.url}/analyse/chshinAnalyseVn/getDepositMoney`,
    depositMoneyExport: `${base.url}/analyse/chshinAnalyseVn/depositMoneyExport`
  },
  //取款概况
  chshoutAnalyseVn: {
    getData: `${base.url}/analyse/chshoutAnalyseVn/getData`,
    withdrawal: `${base.url}/analyse/chshoutAnalyseVn/withdrawal`,
    withdrawalExport: `${base.url}/analyse/chshoutAnalyseVn/withdrawalExport`,
    getPoorData: `${base.url}/analyse/chshoutAnalyseVn/getPoorData`,
    poor: `${base.url}/analyse/chshoutAnalyseVn/poor`,
    poorExport: `${base.url}/analyse/chshoutAnalyseVn/poorExport`
  },
  //交易概况
  realVn: {
    getData: `${base.url}/analyse/dealAnalyseVn/getData`,
    deal: `${base.url}/analyse/dealAnalyseVn/deal`,
    dealExport: `${base.url}/analyse/dealAnalyseVn/dealExport`,
    dealHand: `${base.url}/analyse/dealAnalyseVn/dealHand`,
    dealHandExport: `${base.url}/analyse/dealAnalyseVn/dealHandExport`,
    dealProduction: `${base.url}/analyse/dealAnalyseVn/dealProduction`,
    dealProductionExport: `${base.url}/analyse/dealAnalyseVn/dealProductionExport`
  },
  deviceVn: {
    vendor: `${base.url}/analyse/deviceRecord/deviceStatistical`,
    deviceList: `${base.url}/analyse/deviceRecord/deviceStatisticalList`,
    download: `${base.url}/analyse/deviceRecord/downloadDeviceStatistical`,
    analy: `${base.url}/analyse/deviceRecord/getDeviceRecordInfoAnaly`,
    detail: `${base.url}/analyse/deviceRecord/list`,
    export: `${base.url}/analyse/deviceRecord/export`,
    syndata: `${base.url}/analyse/deviceRecord/syndata`
  },
  //代理设置
  adAgent: {
    rebateSetList: `${base.url}/analyse/adAgent/rebateSet/list`,
    rebateSetDel: `${base.url}/analyse/adAgent/rebateSet/del`,
    rebateSetEdit: `${base.url}/analyse/adAgent/rebateSet/edit`,
    rebateSetDetail: `${base.url}/analyse/adAgent/rebateSet/detail`,
    rebateSetStatus: `${base.url}/analyse/adAgent/rebateSet/status`,

    rebateSetListAll: `${base.url}/analyse/adAgent/rebateSet/listAll`,
    symbolList: `${base.url}/analyse/adAgent/symbol/list`,
    symbolEdit: `${base.url}/analyse/adAgent/symbolConf/edit`,
    symbolHistory: `${base.url}/analyse/adAgent/symbolConf/history`,

    personnelList: `${base.url}/analyse/adAgent/personnel/list`,
    personnelDel: `${base.url}/analyse/adAgent/personnel/del`,
    personnelEdit: `${base.url}/analyse/adAgent/personnel/edit`,
    personnelStatus: `${base.url}/analyse/adAgent/personnel/status`,
    personnelCascader: `${base.url}/analyse/adAgent/personnel/cascader`,
    customerList: `${base.url}/analyse/adAgent/customer/list`,
    customerStatistics: `${base.url}/analyse/adAgent/customer/statistics`,
    customerDown: `${base.url}/analyse/adAgent/customer/down`,
    customerApplyImport: `${base.url}/analyse/adAgent/customerApply/import`,
    customerApplyList: `${base.url}/analyse/adAgent/customerApply/list`,
    customerApplyStatus: `${base.url}/analyse/adAgent//customerApply/status`,
    customerApplyDel: `${base.url}/analyse/adAgent//customerApply/del`,
    levelList: `${base.url}/analyse/adAgent/level/list`,
    rebateLevel: `${base.url}/analyse/adAgent/rebate/levels`,
    rebateDetailList: `${base.url}/analyse/adAgent/rebatedetail/list`,
    rebateDetailTotal: `${base.url}/analyse/adAgent/rebatedetail/total`,
    rebateDetailDown: `${base.url}/analyse/adAgent/rebatedetail/down`,
    personnelApplyList: `${base.url}/analyse/adAgent/personnelApply/list`,
    personnelApplyStatus: `${base.url}/analyse/adAgent/personnelApply/status`,
    personnelApplyDel: `${base.url}/analyse/adAgent/personnelApply/del`,
    rebateMonthProvide: `${base.url}/analyse/adAgent/rebateMonth/provide`,
    rebateMonthList: `${base.url}/analyse/adAgent/rebateMonth/list`,
    excludeCustomers:`${base.url}/analyse/adAgent/exclude/list`,
    delExcludeCustomers:`${base.url}/analyse/adAgent/exclude/del`,
    saveExcludeCustomers:`${base.url}/analyse/adAgent/exclude/add`,

    domainSettingLoad:`${base.url}/analyse/adAgent/domain/setting/load`,
    domainSettingModify:`${base.url}/analyse/adAgent/domain/setting/modify`,
  }
}
